"use strict";

(function (global, factory) {
  factory(require("../froala_3.0.5/js/froala_editor"));
})(void 0, function (FE) {
  "use strict";

  FE = FE && FE.hasOwnProperty("default") ? FE["default"] : FE;
  Object.assign(FE.POPUP_TEMPLATES, {
    "abbr.edit": "[_BUTTONS_]",
    "abbr.insert": "[_BUTTONS_][_INPUT_LAYER_]"
  });

  FE.PLUGINS.cpAbbr = function (editor) {
    var $ = window.$ || require('jquery');

    function get() {
      if (editor.$wp) {
        var c_el = editor.selection.ranges(0).commonAncestorContainer;

        try {
          if (c_el && (c_el.contains && c_el.contains(editor.el) || !editor.el.contains(c_el) || editor.el == c_el)) c_el = null;
        } catch (ex) {
          c_el = null;
        }

        if (c_el && c_el.tagName === "ABBR") return c_el;
        var s_el = editor.selection.element();
        var e_el = editor.selection.endElement();

        if (s_el.tagName != "ABBR" && !editor.node.isElement(s_el)) {
          s_el = $(s_el).parentsUntil(editor.$el, "abbr:first").get(0);
        }

        if (e_el.tagName != "ABBR" && !editor.node.isElement(e_el)) {
          e_el = $(e_el).parentsUntil(editor.$el, "abbr:first").get(0);
        }

        try {
          if (e_el && (e_el.contains && e_el.contains(editor.el) || !editor.el.contains(e_el) || editor.el == e_el)) e_el = null;
        } catch (ex) {
          e_el = null;
        }

        try {
          if (s_el && (s_el.contains && s_el.contains(editor.el) || !editor.el.contains(s_el) || editor.el == s_el)) s_el = null;
        } catch (ex) {
          s_el = null;
        }

        if (e_el && e_el == s_el && e_el.tagName == "ABBR") {
          // We do not clicking at the end / input of abbrs because in IE the selection is changing shortly after mouseup.
          // https://jsfiddle.net/jredzam3/
          if ((editor.browser.msie || editor.helpers.isMobile()) && (editor.selection.info(s_el).atEnd || editor.selection.info(s_el).atStart)) {
            return null;
          }

          return s_el;
        }

        return null;
      } else if (editor.el.tagName == "ABBR") {
        return editor.el;
      }
    }

    function allSelected() {
      var selectedAbbr = [];
      var range;
      var containerEl;
      var abbrs;
      var abbrRange;

      if (editor.win.getSelection) {
        var sel = editor.win.getSelection();

        if (sel.getRangeAt && sel.rangeCount) {
          abbrRange = editor.doc.createRange();

          for (var r = 0; r < sel.rangeCount; ++r) {
            range = sel.getRangeAt(r);
            containerEl = range.commonAncestorContainer;

            if (containerEl && containerEl.nodeType != 1) {
              containerEl = containerEl.parentNode;
            }

            if (containerEl && containerEl.nodeName.toLowerCase() == "abbr") {
              selectedAbbr.push(containerEl);
            } else {
              abbrs = containerEl.getElementsByTagName("abbr");

              for (var i = 0; i < abbrs.length; ++i) {
                abbrRange.selectNodeContents(abbrs[i]);

                if (abbrRange.compareBoundaryPoints(range.END_TO_START, range) < 1 && abbrRange.compareBoundaryPoints(range.START_TO_END, range) > -1) {
                  selectedAbbr.push(abbrs[i]);
                }
              }
            }
          } // abbrRange.detach();

        }
      } else if (editor.doc.selection && editor.doc.selection.type != "Control") {
        range = editor.doc.selection.createRange();
        containerEl = range.parentElement();

        if (containerEl.nodeName.toLowerCase() == "abbr") {
          selectedAbbr.push(containerEl);
        } else {
          abbrs = containerEl.getElementsByTagName("abbr");
          abbrRange = editor.doc.body.createTextRange();

          for (var j = 0; j < abbrs.length; ++j) {
            abbrRange.moveToElementText(abbrs[j]);

            if (abbrRange.compareEndPoints("StartToEnd", range) > -1 && abbrRange.compareEndPoints("EndToStart", range) < 1) {
              selectedAbbr.push(abbrs[j]);
            }
          }
        }
      }

      return selectedAbbr;
    }

    function _edit(e) {
      if (editor.core.hasFocus()) {
        _hideEditPopup(); // Do not show edit popup for abbr when ALT is hit.


        if (e && e.type === "keyup" && (e.altKey || e.which == FE.KEYCODE.ALT)) return true;
        setTimeout(function () {
          // No event passed.
          // Event passed and (left click or other event type).
          if (!e || e && (e.which == 1 || e.type != "mouseup")) {
            var abbr = get();

            if (abbr) {
              if (e) {
                e.stopPropagation();
              }

              _showEditPopup(abbr);
            }
          }
        }, editor.helpers.isIOS() ? 100 : 0);
      }
    }

    function _showEditPopup(abbr) {
      var $popup = editor.popups.get("abbr.edit");
      if (!$popup) $popup = _initEditPopup();
      var $abbr = $(abbr);

      if (!editor.popups.isVisible("abbr.edit")) {
        editor.popups.refresh("abbr.edit");
      }

      editor.popups.setContainer("abbr.edit", editor.$sc);
      var left = $abbr.offset().left + $(abbr).outerWidth() / 2;
      var top = $abbr.offset().top + $abbr.outerHeight();
      editor.popups.show("abbr.edit", left, top, $abbr.outerHeight());
    }

    function _hideEditPopup() {
      editor.popups.hide("abbr.edit");
    }

    function _initEditPopup() {
      // Abbr buttons.
      var abbr_buttons = "";

      if (editor.opts.abbrEditButtons.length >= 1) {
        if (editor.el.tagName == "ABBR" && editor.opts.abbrEditButtons.indexOf("abbrRemove") >= 0) {
          editor.opts.abbrEditButtons.splice(editor.opts.abbrEditButtons.indexOf("abbrRemove"), 1);
        }

        abbr_buttons = '<div class="fr-buttons">' + editor.button.buildList(editor.opts.abbrEditButtons) + "</div>";
      }

      var template = {
        buttons: abbr_buttons
      }; // Set the template in the popup.

      var $popup = editor.popups.create("abbr.edit", template);

      if (editor.$wp) {
        editor.events.$on(editor.$wp, "scroll.abbr-edit", function () {
          if (get() && editor.popups.isVisible("abbr.edit")) {
            _showEditPopup(get());
          }
        });
      }

      return $popup;
    }
    /**
     * Hide abbr insert popup.
     */


    function _hideInsertPopup() {}

    function _refreshInsertPopup() {
      var $popup = editor.popups.get("abbr.insert");
      var abbr = get();

      if (abbr) {
        var $abbr = $(abbr);
        var text_inputs = $popup.find('input.fr-abbr-attr[type="text"]');
        var i;
        var $input;

        for (i = 0; i < text_inputs.length; i++) {
          $input = $(text_inputs[i]);
          $input.val($abbr.attr($input.attr("name") || ""));
        }

        $popup.find('input.fr-abbr-attr[type="text"][name="text"]').val($abbr.text());
      } else {
        $popup.find('input.fr-abbr-attr[type="text"]').val("");
        $popup.find('input.fr-abbr-attr[type="text"][name="text"]').val(editor.selection.text());
      }

      $popup.find("input.fr-abbr-attr").trigger("change");
      $popup.find('.fr-abbr-attr[name="text"]').parent().show();
    }

    function _showInsertPopup() {
      var $btn = editor.$tb.find('.fr-command[data-cmd="insertAbbr"]');
      var $popup = editor.popups.get("abbr.insert");
      if (!$popup) $popup = _initInsertPopup();

      if (!$popup.hasClass("fr-active")) {
        editor.popups.refresh("abbr.insert");
        editor.popups.setContainer("abbr.insert", editor.$tb || editor.$sc);

        if (!$btn.is("hidden")) {
          var left = $btn.offset().left + $btn.outerWidth() / 2;
          var top = $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);
          editor.popups.show("abbr.insert", left, top, $btn.outerHeight());
        } else {
          editor.position.forSelection($popup);
          editor.popups.show("abbr.insert");
        }
      }
    }

    function _initInsertPopup(delayed) {
      if (delayed) {
        editor.popups.onRefresh("abbr.insert", _refreshInsertPopup);
        editor.popups.onHide("abbr.insert", _hideInsertPopup);
        return true;
      } // Image buttons.


      var abbr_buttons = "";

      if (editor.opts.abbrInsertButtons.length >= 1) {
        abbr_buttons = '<div class="fr-buttons">' + editor.button.buildList(editor.opts.abbrInsertButtons) + "</div>";
      } // Image by url layer.


      var input_layer = "";
      var tab_idx = 0;
      input_layer = '<div class="fr-abbr-insert-layer fr-layer fr-active" id="fr-abbr-insert-layer-' + editor.id + '">';
      input_layer += '<div class="fr-input-line"><input id="fr-abbr-insert-layer-url-' + editor.id + '" name="title" type="text" class="fr-abbr-attr" placeholder="' + editor.language.translate("Title") + '" tabIndex="' + ++tab_idx + '"></div>';
      input_layer += '<div class="fr-input-line"><input id="fr-abbr-insert-layer-text-' + editor.id + '" name="text" type="text" class="fr-abbr-attr" placeholder="' + editor.language.translate("Abbreviation") + '" tabIndex="' + ++tab_idx + '"></div>';
      input_layer += '<div class="fr-action-buttons"><button class="fr-command fr-submit" role="button" data-cmd="abbrInsert" href="#" tabIndex="' + ++tab_idx + '" type="button">' + editor.language.translate("Insert") + "</button></div></div>";
      var template = {
        buttons: abbr_buttons,
        input_layer: input_layer
      }; // Set the template in the popup.

      var $popup = editor.popups.create("abbr.insert", template);

      if (editor.$wp) {
        editor.events.$on(editor.$wp, "scroll.abbr-insert", function () {
          if (get && editor.popups.isVisible("abbr.insert")) {
            update();
          }
        });
      }

      return $popup;
    }

    function remove() {
      var abbr = get();
      if (editor.events.trigger("abbr.beforeRemove", [abbr]) === false) return false;

      if (abbr) {
        editor.selection.save();
        $(abbr).replaceWith($(abbr).html());
        editor.selection.restore();

        _hideEditPopup();
      }
    }

    function _init() {
      // Edit on keyup.
      editor.events.on("keyup", function (e) {
        if (e.which != FE.KEYCODE.ESC) {
          _edit(e);
        }
      });
      editor.events.on("window.mouseup", _edit);

      if (editor.helpers.isMobile()) {
        editor.events.$on(editor.$doc, "selectionchange", _edit);
      }

      _initInsertPopup(true); // Init on abbr.


      if (editor.el.tagName == "ABBR") {
        editor.$el.addClass("fr-view");
      } // Hit ESC when focus is in abbr edit popup.


      editor.events.on("toolbar.esc", function () {
        if (editor.popups.isVisible("abbr.edit")) {
          editor.events.disableBlur();
          editor.events.focus();
          return false;
        }
      }, true);
    }

    function insertCallback() {
      var $popup = editor.popups.get("abbr.insert");
      var text_inputs = $popup.find('input.fr-abbr-attr[type="text"]');
      var title = (text_inputs.filter('[name="title"]').val() || "").trim();
      var text = text_inputs.filter('[name="text"]').val();
      var attrs = {};
      var $input;
      var i;

      for (i = 0; i < text_inputs.length; i++) {
        $input = $(text_inputs[i]);

        if (["title", "text"].indexOf($input.attr("name")) < 0) {
          attrs[$input.attr("name")] = $input.val();
        }
      }

      var t = editor.helpers.scrollTop();
      insert(title, text, attrs);
      $(editor.o_win).scrollTop(t);
    }

    function _split() {
      if (!editor.selection.isCollapsed()) {
        editor.selection.save();
        var markers = editor.$el.find(".fr-marker").addClass("fr-unprocessed").toArray();

        while (markers.length) {
          var $marker = $(markers.pop());
          $marker.removeClass("fr-unprocessed"); // Get deepest parent.

          var deep_parent = editor.node.deepestParent($marker.get(0));

          if (deep_parent) {
            var node = $marker.get(0);
            var close_str = "";
            var open_str = "";

            do {
              node = node.parentNode;

              if (!editor.node.isBlock(node)) {
                close_str = close_str + editor.node.closeTagString(node);
                open_str = editor.node.openTagString(node) + open_str;
              }
            } while (node != deep_parent);

            var marker_str = editor.node.openTagString($marker.get(0)) + $marker.html() + editor.node.closeTagString($marker.get(0));
            $marker.replaceWith('<span id="fr-break"></span>');
            var h = deep_parent.outerHTML;
            h = h.replace(/<span id="fr-break"><\/span>/g, close_str + marker_str + open_str);
            deep_parent.outerHTML = h;
          }

          markers = editor.$el.find(".fr-marker.fr-unprocessed").toArray();
        }

        editor.html.cleanEmptyTags();
        editor.selection.restore();
      }
    }
    /**
     * Insert abbr into the editor.
     */


    function insert(title, text, attrs) {
      if (typeof attrs == "undefined") attrs = {};
      if (editor.events.trigger("abbr.beforeInsert", [title, text, attrs]) === false) return false;

      if (editor.el.tagName != "ABBR") {
        editor.selection.restore();
        editor.popups.hide("abbr.insert");
      } else if (editor.el.tagName == "ABBR") {
        editor.$el.focus();
      }

      var original_title = title; // Format text.

      text = text || ""; // Check if we have selection only in one abbr.

      var abbr = get();
      var $abbr;

      if (abbr) {
        $abbr = $(abbr);
        $abbr.attr("title", title); // Change text if it is different.

        if (text.length > 0 && $abbr.text() != text) {
          var child = $abbr.get(0);

          while (child.childNodes.length === 1 && child.childNodes[0].nodeType == Node.ELEMENT_NODE) {
            child = child.childNodes[0];
          }

          $(child).text(text);
        }

        $abbr.prepend(FE.START_MARKER).append(FE.END_MARKER); // Set attributes.

        $abbr.attr(attrs);
        editor.selection.restore();
      } else {
        // Remove current abbr.
        editor.format.remove("abbr"); // Nothing is selected.

        if (editor.selection.isCollapsed()) {
          text = text.length === 0 ? original_title : text;
          editor.html.insert('<abbr title="' + title + '">' + FE.START_MARKER + text.replace(/&/g, "&amp;") + FE.END_MARKER + "</abbr>");
          editor.selection.restore();
        } else {
          if (text.length > 0 && text != editor.selection.text().replace(/\n/g, "")) {
            editor.selection.remove();
            editor.html.insert('<abbr title="' + title + '">' + FE.START_MARKER + text.replace(/&/g, "&amp;") + FE.END_MARKER + "</abbr>");
            editor.selection.restore();
          } else {
            _split(); // Add abbr.


            editor.format.apply("abbr", {
              title: title
            });
          }
        } // Set attributes.


        var abbrs = allSelected();

        for (var i = 0; i < abbrs.length; i++) {
          $abbr = $(abbrs[i]);
          $abbr.attr(attrs);
          $abbr.removeAttr("_moz_dirty");
        } // Show abbr edit if only one abbr.


        if (abbrs.length == 1 && editor.$wp) {
          $(abbrs[0]).prepend(FE.START_MARKER).append(FE.END_MARKER);
          editor.selection.restore();
        }
      } // Hide popup and try to edit.


      _edit();
    }

    function update() {
      _hideEditPopup();

      var abbr = get();

      if (abbr) {
        var $popup = editor.popups.get("abbr.insert");
        if (!$popup) $popup = _initInsertPopup();

        if (!editor.popups.isVisible("abbr.insert")) {
          editor.popups.refresh("abbr.insert");
          editor.selection.save();

          if (editor.helpers.isMobile()) {
            editor.events.disableBlur();
            editor.$el.blur();
            editor.events.enableBlur();
          }
        }

        editor.popups.setContainer("abbr.insert", editor.$sc);
        var $ref = $(abbr);
        var left = $ref.offset().left + $ref.outerWidth() / 2;
        var top = $ref.offset().top + $ref.outerHeight();
        editor.popups.show("abbr.insert", left, top, $ref.outerHeight());
      }
    }

    function back() {
      editor.events.disableBlur();
      editor.selection.restore();
      editor.events.enableBlur();
      var abbr = get();

      if (abbr && editor.$wp) {
        editor.selection.restore();

        _hideEditPopup();

        _edit();
      } else if (editor.el.tagName == "ABBR") {
        editor.$el.focus();

        _edit();
      } else {
        editor.popups.hide("abbr.insert");
        editor.toolbar.showInline();
      }
    }

    return {
      _init: _init,
      remove: remove,
      showInsertPopup: _showInsertPopup,
      insertCallback: insertCallback,
      insert: insert,
      update: update,
      get: get,
      allSelected: allSelected,
      back: back
    };
  };

  Object.assign(FE.DEFAULTS, {
    abbrEditButtons: ["abbrEdit", "abbrRemove"],
    abbrInsertButtons: ["abbrBack", "|"]
  }); // Register the abbr command.

  FE.DefineIcon("abbrIcon", {
    NAME: "compress fr-custom-rotate45",
    template: "font_awesome"
  });
  FE.RegisterCommand("insertAbbr", {
    title: "Insert Abbreviation",
    icon: "abbrIcon",
    undo: false,
    focus: true,
    refreshOnCallback: false,
    popup: true,
    callback: function callback() {
      if (!this.popups.isVisible("abbr.insert")) {
        this.cpAbbr.showInsertPopup();
      } else {
        if (this.$el.find(".fr-marker").length) {
          this.events.disableBlur();
          this.selection.restore();
        }

        this.popups.hide("abbr.insert");
      }
    },
    plugin: "cpAbbr"
  });
  FE.DefineIcon("abbrEdit", {
    NAME: "edit",
    template: "font_awesome"
  });
  FE.RegisterCommand("abbrEdit", {
    title: "Edit Abbreviation",
    undo: false,
    refreshAfterCallback: false,
    popup: true,
    callback: function callback() {
      this.cpAbbr.update();
    },
    refresh: function refresh($btn) {
      var abbr = this.cpAbbr.get();

      if (abbr) {
        $btn.removeClass("fr-hidden");
      } else {
        $btn.addClass("fr-hidden");
      }
    },
    plugin: "cpAbbr"
  });
  FE.DefineIcon("abbrRemove", {
    NAME: "unlink",
    template: "font_awesome"
  });
  FE.RegisterCommand("abbrRemove", {
    title: "Remove Abbreviation",
    callback: function callback() {
      this.cpAbbr.remove();
    },
    refresh: function refresh($btn) {
      var abbr = this.cpAbbr.get();

      if (abbr) {
        $btn.removeClass("fr-hidden");
      } else {
        $btn.addClass("fr-hidden");
      }
    },
    plugin: "cpAbbr"
  });
  FE.RegisterCommand("abbrInsert", {
    focus: false,
    refreshAfterCallback: false,
    callback: function callback() {
      this.cpAbbr.insertCallback();
    },
    refresh: function refresh($btn) {
      var abbr = this.cpAbbr.get();

      if (abbr) {
        $btn.text(this.language.translate("Update"));
      } else {
        $btn.text(this.language.translate("Insert"));
      }
    },
    plugin: "cpAbbr"
  });
  FE.DefineIcon("abbrBack", {
    NAME: "arrow-left",
    template: "font_awesome"
  });
  FE.RegisterCommand("abbrBack", {
    title: "Back",
    undo: false,
    focus: false,
    back: true,
    refreshAfterCallback: false,
    callback: function callback() {
      this.cpAbbr.back();
    },
    refresh: function refresh($btn) {
      var abbr = this.cpAbbr.get() && this.doc.hasFocus();

      if (!abbr && !this.opts.toolbarInline) {
        $btn.addClass("fr-hidden");
        $btn.next(".fr-separator").addClass("fr-hidden");
      } else {
        $btn.removeClass("fr-hidden");
        $btn.next(".fr-separator").removeClass("fr-hidden");
      }
    },
    plugin: "cpAbbr"
  });
});